document.addEventListener('DOMContentLoaded', function() {

	if (window.location.pathname.indexOf('/prescribing-information') === -1) {
		
		let usAlert = sessionStorage.getItem('usAlert');
		
		if (!usAlert) {
			
			// Bootstrap 5
			// let usPopup = new bootstrap.Modal(document.getElementById("usPopup"), {});
			// usPopup.show();
			
			// bootstrap 4
			$('#usPopup').modal('show'); 
			
			let okBtn = document.querySelector('#usPopup .btn-ok');
			okBtn.addEventListener('click', function (event) {
				sessionStorage.setItem('usAlert', true);
				$('#usPopup').modal('hide');
			}, true);
			
		} 
		
	}
});
